import { MutationTree } from "vuex";
import { PlatformLogsState } from "./platformLogs.module";
import {
    PlatformLog,
    PlatformLogPagination,
    PlatformLogStats,
    PlatformLogAppliedFilters,
    PlatformLogsFilters,
} from "@/interfaces/panel/platform-logs.model";

export const PLATFORM_LOGS_MUTATIONS: MutationTree<PlatformLogsState> = {
    SET_LOADING(state, loading: boolean) {
        state.loading = loading;
    },

    SET_PLATFORM_LOGS(state, logs: PlatformLog[]) {
        state.platformLogs = logs;
    },

    SET_PAGINATION(state, pagination: PlatformLogPagination) {
        state.pagination = pagination;
    },

    SET_STATS(state, stats: PlatformLogStats) {
        state.stats = stats;
    },

    SET_APPLIED_FILTERS(state, appliedFilters: PlatformLogAppliedFilters) {
        state.appliedFilters = appliedFilters;
    },

    SET_FILTERS(state, filters: PlatformLogsFilters) {
        state.filters = { ...state.filters, ...filters };
    },

    RESET_FILTERS(state) {
        state.filters = {
            page: 1,
            pageSize: 25,
            sortBy: "createdAt",
            sortOrder: "desc",
            includeTotals: true,
            withRelations: true,
        };
    },
};
